import React from 'react';
import { Rate } from 'antd';
import { nullSafeGet } from '../../utils/DataAccessUtils';

export default function RatingComponent({ rating, numRatings = 0, tags = [], tagCountToShow }) {
	const [tagsToShow, setTagsToShow] = React.useState([]);

	React.useEffect(() => {
		const sortedTags = [...tags].sort((a, b) => {
			const countDifference = nullSafeGet('count', b) - nullSafeGet('count', a);
			if (countDifference !== 0) {
				return countDifference;
			}
			return (
				nullSafeGet('reviewTag.isPositiveSentiment', b) -
				nullSafeGet('reviewTag.isPositiveSentiment', a)
			);
		});
		if (tagCountToShow) {
			setTagsToShow(sortedTags.slice(0, tagCountToShow));
		} else {
			setTagsToShow(sortedTags);
		}
	}, [tags, tagCountToShow]);

	return (
		<div className="mt-2 flex flex-col ">
			<div className="flex flex-row items-center gap-x-2 text-sm text-gray-400">
				{parseFloat(rating).toFixed(2)}
				<Rate style={{ fontSize: 12 }} disabled defaultValue={rating} allowHalf />
				{numRatings > 0 ? `${numRatings} reviews` : ''}
			</div>
			<div className="mt-2 flex flex-row flex-wrap gap-2">
				{tagsToShow.length
					? tagsToShow.map((tag) => {
							return (
								<div
									className={`relative inline-flex items-center whitespace-nowrap rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${
										nullSafeGet('reviewTag.isPositiveSentiment', tag)
											? `bg-green-50 text-green-700 ring-green-600/20`
											: `bg-red-50 text-red-700 ring-red-600/10`
									}`}
								>
									<span>
										{nullSafeGet('reviewTag.title', tag)}{' '}
										{nullSafeGet('count', tag) ? `(${nullSafeGet('count', tag)})` : null}
									</span>
								</div>
							);
					  })
					: null}
			</div>
		</div>
	);
}
